import { formikErrorHandler } from './formikUtils';
import { errorAlert } from '../components/ToastMessage';

// TODO add props
export const errorHandler = ({ e, formik }): void => {
  console.log('errorHandler----', e.response);
  if (e.response?.status === 401) return;

  if ( e.response?.status !== 400 && (
    e.response?.data?.General
    || e.response?.data?.errors?.General
    || e.response?.data?.errors?.EmailAlreadyExist
    || e.response?.data?.['Captcha']
  )) {
    errorAlert({
      title:  e.response?.data?.General?.[0]
        || e.response?.data?.errors?.General?.[0]
        || e.response?.data?.errors?.EmailAlreadyExist?.[0]
        || e.response?.data?.['Captcha']?.[0]
        || e.response?.data?.title
        || e.response?.data
        || 'Something went wrong',
      duration: 0,
      closable: true
    });
  } else if (e.response?.data?.errors) {
    formikErrorHandler({ formik, data: e.response?.data?.errors });
  } else if (e.response?.data) {
    errorAlert({
      title: e.response?.data || 'Something went wrong',
      duration: 0,
      closable: true
    });
  } else {
    formikErrorHandler({ formik, data: e.response?.data });
  }
};

export const generalErrorHandler = ({ e }): void => {
  if (e.response?.data?.General || e.response?.data?.errors?.General) {
    errorAlert({
      title: e.response?.data?.General?.[0] || e.response?.data?.errors?.General?.[0] || 'Something went wrong',
      duration: 0,
      closable: true
    });
  }
};

export const requestErrorHandler = (e: any): void => {
  console.log('errorHandler----2', e.response);
  if (e.response?.status === 401) return;

  if (e.response?.data?.General
    || e.response?.data?.errors?.General
    || e.response?.data?.errors?.EmailAlreadyExist
    || e.response?.data?.['Captcha']) {
    errorAlert({
      title: e.response?.data?.General?.[0]
        || e.response?.data?.errors?.General?.[0]
        || e.response?.data?.errors?.EmailAlreadyExist?.[0]
        || e.response?.data?.['Captcha']?.[0]
        || e.response?.data?.title
        || e.response?.data
        || 'Something went wrong',
      duration: 0,
      closable: true
    });
  } else {
    errorAlert({
      title: 'Something went wrong',
      duration: 0,
      closable: true
    });
  }
};
